import React, { useEffect, useState } from 'react';
import AddNewTask from 'src/components/Task/AddNewTask';
import HeaderContentBlock from 'src/components/Common/HeaderContentBlock';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { deleteTask, taskList } from 'src/services/Task';
import ResponsivTaskListAccordion from 'src/components/Responsive/task/ResponsivTaskListAccordion';
import { dateTimeFormate, tokenDecode } from 'src/utils/function';
import ResponsiveHeaderContentBlock from 'src/components/Responsive/ResponsiveHeaderContentBlock';
import ModalContentBlock from 'src/components/Common/ModalContentBlock';
import ConfirmationPopUp from 'src/components/Common/ConfirmationPopUp';
import { toast } from 'react-toastify';
import { FaTrash, FaSpinner } from 'react-icons/fa';
import TaskSortFilter from 'src/components/Task/TaskSortFilter';
import SortFilterContentModal from 'src/components/Common/SortFilterContentModal';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'src/constants/path';
import { Tooltip } from 'flowbite-react';
import { taskStatus } from 'src/constants/general';

const Task = () => {
    const [addNewTask, setAddNewTask] = useState(false);
    const [sortModal, setSortModal] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState(50);
    const [first, setFirst] = useState(0);
    const [taskListData, setTaskListData] = useState([]);
    const [totalTaskRecords, setTotalTaskRecords] = useState(0);
    const [openAcoordionResponsive, setOpenAcoordionResponsive] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [confirnModalOpen, setConfirmModalOpen] = useState<any>({ id: null });
    const [userData, setUserData] = useState<any>({});
    const [filterApply, setFilterApply] = useState(0);
    const [sortBy, setSortBy] = useState({
        date: { name: 'Newest', value: 'latest' },
        name: null,
    });
    const navigate = useNavigate();

    const [filterBy, setFilterBy] = useState({
        startDateTo: '',
        startDateFrom: '',
        endDateTo: '',
        endDateFrom: '',
    });
    const [startDateTo, setStartDateTo] = useState(null);
    const [formateStartDateTo, setFormateStartDateTo] = useState('Start Date To');
    const [startDateFrom, setStartDateFrom] = useState(null);
    const [formateStartDateFrom, setFormateStartDateFrom] = useState('Start Date From');
    const [endDateTo, setEndDateTo] = useState(null);
    const [formateEndDateTo, setFormateEndDateTo] = useState('End Date To');
    const [endDateFrom, setEndDateFrom] = useState(null);
    const [formateEndDateFrom, setFormateEndDateFrom] = useState('End Date From');

    const dateProps = {
        startDateTo,
        formateStartDateTo,
        startDateFrom,
        formateStartDateFrom,
        endDateTo,
        formateEndDateTo,
        endDateFrom,
        formateEndDateFrom,

        setStartDateTo,
        setFormateStartDateTo,
        setStartDateFrom,
        setFormateStartDateFrom,
        setEndDateTo,
        setFormateEndDateTo,
        setEndDateFrom,
        setFormateEndDateFrom,
    };

    const getToken = async () => {
        const token = await tokenDecode();
        setUserData(token);
    };
    useEffect(() => {
        getToken();
    }, []);

    const apiDataCall = () => {
        const controller = new AbortController();
        const signal = controller.signal;
        let isSearch = searchInput ? `&search=${searchInput}` : '';
        let userId = userData ? `&userId=${userData?.id}` : '';
        let isAdmin = userData?.roleName?.includes('super_admin') ? `&isAdmin=true` : `&isAdmin=false`;

        if (filterApply) {
            let startTo = filterBy.startDateTo ? `&startDateTo=${filterBy.startDateTo}` : '';
            let startFrom = filterBy.startDateFrom ? `&startDateFrom=${filterBy.startDateFrom}` : '';
            let endTo = filterBy.endDateTo ? `&endDateTo=${filterBy.endDateTo}` : '';
            let endFrom = filterBy.endDateFrom ? `&endDateFrom=${filterBy.endDateFrom}` : '';

            getList(`?limit=10&page=${page}${isSearch}${startTo}${startFrom}${endTo}${endFrom}${userId}${isAdmin}`, signal);
        } else {
            getList(`?limit=10&page=${page}${isSearch}${userId}${isAdmin}`, signal);
        }

        return () => controller.abort();
    };

    useEffect(() => {
        apiDataCall();
    }, [page, searchInput, rows, filterApply, userData]);

    const getList = async (url: string, signal?: any) => {
        try {
            setIsLoading(true);
            const resData = await taskList(url, signal);
            const data = resData?.data?.data;
            setTaskListData(data.tasks);
            setTotalTaskRecords(data.total);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };
    const handleRowClick = (row: any) => {
        if (userData?.permissions?.includes('task_update') || userData?.permissions?.includes('task_status_update')) {
            setIsUpdate(true);
            setAddNewTask(true);
            setSelectedRowData(row.data);
        }
    };
    const handleFilterClear = () => {
        setPage(0);
        setFirst(0);
        setSortModal(false);
        setFilterApply(0);
        setSortBy({
            date: { name: 'All', value: '' },

            name: null,
        });
        setFilterBy({
            startDateTo: '',
            startDateFrom: '',
            endDateTo: '',
            endDateFrom: '',
        });

        setFormateStartDateTo('Start Date To');
        setStartDateTo(null);
        setFormateStartDateFrom('Start Date From');
        setStartDateFrom(null);
        setEndDateTo(null);
        setFormateEndDateTo('End Date To');
        setEndDateFrom(null);
        setFormateEndDateFrom('End Date From');
    };
    const handleFilterApply = () => {
        setPage(0);
        setFilterApply(filterApply + 1);
        setSortModal(false);
    };

    const handleSearch = (e: any) => {
        setPage(0);
        setSearchInput(e.target.value);
    };
    const newTaskSuccess = () => {
        if (page === 0) {
            apiDataCall();
        } else {
            setPage(0);
            setFirst(0);
        }
        setAddNewTask(false);
        setBtnDisabled(false);
        setIsUpdate(false);
        setSelectedRowData(null);
    };
    const onPageChange = (event: any) => {
        setFirst(event.first);
        setRows(event.rows);
        setPage(event.page);
    };

    const GetTitle = (row: any) => <div>{row?.title}</div>;
    const GetDescription = (row: any) => <div>{row?.description || row?.description !== '' ? row?.description : '-'}</div>;
    const GetCreatedBy = (row: any) => <div>{row?.createdBy}</div>;
    const GetStatus = (row: any) => {
        const statusKey = row?.status as keyof typeof taskStatus;
        return <div className="capitalize"> {taskStatus[statusKey] ?? '-'}</div>;
    };
    const GetAssignToUsers = (row: any) => {
        if (row?.assignedTo === undefined || row?.assignedTo === null || row?.assignedTo === '[]') {
            return '-';
        }
        const user = () => (
            <div>
                {row.assignedToUsers.map((data: any, index: number) => (
                    <p className="truncate" key={index}>{`${data.name}`}</p>
                ))}
            </div>
        );

        return row?.assignedToUsers?.length === 1 ? (
            <p className="truncate">{`${row.assignedToUsers[0].name}`}</p>
        ) : (
            <div className="flex">
                <p className="truncate me-[6px]">{`${row.assignedToUsers[0].name}..`}</p>
                <Tooltip className="bg-black text-white" content={<>{user()}</>}>
                    <div className="w-4 h-4 px-2 pt-0.5 pb-1 bg-indigo-500 rounded-2xl flex-col justify-center items-center gap-2 inline-flex">
                        <div className="text-white text-xs font-medium font-['Satoshi Variable']">{row?.assignedToUsers?.length}</div>
                    </div>
                </Tooltip>
            </div>
        );
    };

    const GetDeleteAction = (row: any) => (
        <div className="flex gap-2">
            {userData?.permissions?.includes('task_delete') && (
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        setConfirmModalOpen({ id: row.id });
                    }}
                    className=" p-2 bg-red-100 text-red-700 rounded-lg justify-center items-center inline-flex"
                >
                    <FaTrash size={14} />
                </div>
            )}
            {userData?.permissions?.includes('task_progress_note_read') && (
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        let userId = userData?.id ? `&userId=${userData.id}` : '';
                        let isAdmin = userData?.roleName?.includes('super_admin') ? `&isAdmin=true` : `&isAdmin=false`;
                        navigate(`${PATH.TASKPROGRESSNOTE}`, { state: { id: row.id, userId: userId, isAdmin: isAdmin, title: row.title, emp: row.empIds } });
                    }}
                    className=" p-2 bg-black text-white rounded-lg justify-center items-center inline-flex min-w-[100px]"
                >
                    Progress Note
                </div>
            )}
        </div>
    );
    const GetEmpList = (row: any) => {
        if (row?.empIds === undefined || row?.empIds === null || row?.empIds === '[]') {
            return '-';
        }
        const employee = () => (
            <div>
                {row.empList
                    ?.filter((data: any) => data?.name || data?.surname)
                    .map((data: any, index: number) => (
                        <p className="truncate" key={index}>
                            {data.name && data.surname ? `${data.name} ${data.surname}` : `${data.name ?? ''} ${data.surname ?? ''}`.trim()}
                        </p>
                    ))}
            </div>
        );

        if (row?.empList?.length === 0) {
            return '-';
        }

        return row?.empList?.length === 1 ? (
            <p className="truncate">{`${row.empList[0].name} ${row.empList[0].surname}`}</p>
        ) : (
            <div className="flex">
                <p className="truncate me-[6px]">{`${row.empList[0].name} ${row.empList[0].surname}..`}</p>
                <Tooltip className="bg-black text-white" content={<>{employee()}</>}>
                    <div className="w-4 h-4 px-2 pt-0.5 pb-1 bg-indigo-500 rounded-2xl flex-col justify-center items-center gap-2 inline-flex">
                        <div className="text-white text-xs font-medium font-['Satoshi Variable']">{row?.empList?.length}</div>
                    </div>
                </Tooltip>
            </div>
        );
    };

    const GetStartDate = (row: any) => <div>{row.startDate ? dateTimeFormate(row.startDate, 'DD MMM, YYYY') : '-'}</div>;
    const GetEndDate = (row: any) => <div>{row.endDate ? dateTimeFormate(row.endDate, 'DD MMM, YYYY') : '-'}</div>;
    const handleDeleteClick = async (id: any) => {
        try {
            const res = await deleteTask(`?taskId=${id}`);

            if (res?.status === 200) {
                toast.success(`Task deleted successfully.`);
                let userId = userData?.id ? `&userId=${userData.id}` : '';
                let isAdmin = userData?.roleName?.includes('super_admin') ? `&isAdmin=true` : `&isAdmin=false`;
                if (searchInput) {
                    getList(`?page=${page}&limit=${rows}&search=${searchInput}${userId}${isAdmin}`);
                } else {
                    getList(`?page=${page}&limit=${rows}${userId}${isAdmin}`);
                }
            } else {
                toast.error(res?.data?.message || 'Operation failed. Please try again.');
            }
        } catch (err) {
            // console.log(err);
        }
        setConfirmModalOpen({ id: null });
    };

    return (
        <div>
            <div>
                <ResponsiveHeaderContentBlock
                    sortOnClick={() => setSortModal(true)}
                    closeOnClick={() => {
                        setAddNewTask(false);
                        setSelectedRowData(null);
                        setIsUpdate(false);
                    }}
                    addNewOnClick={() => setAddNewTask(true)}
                    isDisabled={addNewTask}
                    searchOnchange={handleSearch}
                    searchInput={searchInput}
                    isNext={addNewTask}
                    isSave={userData?.permissions?.includes('task_create') ? true : false}
                />
            </div>
            <HeaderContentBlock
                closeOnClick={() => {
                    setAddNewTask(false);
                    setSelectedRowData(null);
                    setIsUpdate(false);
                }}
                saveOnClick={() => setIsSave(true)}
                addNewOnClick={() => setAddNewTask(true)}
                nextStep={addNewTask}
                addNewBtnText={'Add new Task'}
                isEmploy={true}
                headerText="Tasks"
                isDisabled={btnDisabled}
                searchOnchange={handleSearch}
                searchInput={searchInput}
                isSave={userData?.permissions?.includes('task_create') ? true : false}
                sortOnClick={() => setSortModal(true)}
            />
            {addNewTask && (
                <AddNewTask
                    setIsSave={setIsSave}
                    isSave={isSave}
                    isOnSuccess={() => {
                        newTaskSuccess();
                    }}
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isUpdate={isUpdate}
                    selectedRowData={selectedRowData}
                />
            )}
            <div className={`pt-5 pb-0 w-full ${addNewTask ? 'hidden' : 'max-lg:block hidden'}`}>
                {isLoading ? (
                    <div className="flex items-center justify-center 200 h-screen bg-gray-50">
                        <div className="text-center text-gray-500 text-lg font-medium">
                            <FaSpinner className="animate-spin text-2xl text-gray-600" />
                        </div>
                    </div>
                ) : (
                    <>
                        {taskListData?.length === 0 && (
                            <div
                                className=" bg-white max-md:h-10 flex justify-center items-center max-lg:font-semibold
                         max-lg:text-xl max-lg:h-12  max-md:font-medium max-md:text-lg"
                            >
                                No Task Found
                            </div>
                        )}
                        <ResponsivTaskListAccordion
                            taskListData={taskListData}
                            openAcoordionResponsive={openAcoordionResponsive}
                            setOpenAcoordionResponsive={setOpenAcoordionResponsive}
                            onRowClick={handleRowClick}
                            GetDeleteAction={GetDeleteAction}
                            userData={userData}
                            GetEmpList={GetEmpList}
                            GetAssignToUsers={GetAssignToUsers}
                            GetStatus={GetStatus}
                        />
                        <div className="mt-5">
                            <Paginator
                                first={first}
                                rows={rows}
                                totalRecords={totalTaskRecords}
                                onPageChange={onPageChange}
                                className="datatable_pagination"
                                template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            />
                        </div>
                    </>
                )}
            </div>
            <div className="py-6 hidden lg:block">
                <DataTable value={taskListData} tableClassName="logdatatable" emptyMessage="No Task Found" className="" loading={isLoading} onRowClick={handleRowClick}>
                    <Column field="title" header="Title" body={GetTitle}></Column>
                    <Column field="description" header="Description" body={GetDescription}></Column>
                    <Column field="startDate" header="Start Date" body={GetStartDate}></Column>
                    <Column field="endDate" header="End Date" body={GetEndDate}></Column>
                    <Column field="assignedTo" header="Assigned To" body={GetAssignToUsers}></Column>
                    <Column field="createdBy" header="Created By" body={GetCreatedBy}></Column>
                    <Column field="empList" header="Employees" body={GetEmpList}></Column>
                    <Column field="status" header="Status" body={GetStatus}></Column>
                    {(userData?.permissions?.includes('task_delete') || userData?.permissions?.includes('task_progress_note_read')) && (
                        <Column field="action" header="Action" body={GetDeleteAction}></Column>
                    )}
                </DataTable>
                <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalTaskRecords}
                    onPageChange={onPageChange}
                    className="datatable_pagination"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                />
            </div>
            {sortModal && (
                <SortFilterContentModal setSortModal={setSortModal} onFilterClear={handleFilterClear} onFilterApply={handleFilterApply} isJob={true} isModalOpen={sortModal} customClass={'!w-[450px]'}>
                    <TaskSortFilter sortBy={sortBy} setSortBy={setSortBy} dateProps={dateProps} filterBy={filterBy} setFilterBy={setFilterBy} />
                </SortFilterContentModal>
            )}
            {confirnModalOpen.id && confirnModalOpen.id !== null && (
                <ModalContentBlock onclose={() => setConfirmModalOpen({ id: null })} isMoreClass="logout_modal" isModalOpen={confirnModalOpen}>
                    <ConfirmationPopUp
                        confirmText="Are you sure you want to delete this Task?"
                        submitOnClick={() => {
                            handleDeleteClick(confirnModalOpen.id);
                        }}
                        cancelOnClick={() => setConfirmModalOpen({ id: null })}
                    />
                </ModalContentBlock>
            )}
        </div>
    );
};

export default Task;
